import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "minus-sm",
  "use": "minus-sm-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"minus-sm\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4.5 7.5h7s.5 0 .5.5-.5.5-.5.5h-7S4 8.5 4 8s.5-.5.5-.5z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol